import Ricola from 'ricola3';
import uiRouter from 'angular-ui-router';

import searchInterfaceConfig from './search-interface.config';
import searchInterfaceComponent from './search-interface.component';

import searchInterfaceShared from './shared/';

export default angular.module('searchEngineFrontend.searchInterface', [
  Ricola,
  uiRouter,
  searchInterfaceShared.name
])
  .config(searchInterfaceConfig)
  .component('searchInterface', searchInterfaceComponent);


// WEBPACK FOOTER //
// ./src/search-interface/index.js